import { CategoriaReadingDtoProps } from "./DTOs/CategoriaReadingDto"

export const categoriaPadresAdapter = (
  categoria: CategoriaReadingDtoProps
): CategoriaReadingDtoProps => ({
  id: categoria?.id,
  cantidadArticulos: categoria?.cantidadArticulos,
  categoriaPadreId: categoria?.categoriaPadreId,
  ficheroId: categoria?.ficheroId,
  imagenBase64: categoria?.imagenBase64,
  imagenMediaType: categoria?.imagenMediaType,
  nombre: categoria?.nombre,
  subCategorias: categoria?.subCategorias,
})
